import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import Calculator from "../../components/Calculator";
import CalculatorNew from "../../components/CalculatorNew";
import useTopicQuestions from "../../hooks/useTopicQuestionsNew";
import { Scale } from 'react-scaling';
//NEW CSV STUFF
import Papa from "papaparse";
import year1extraquestions from '../../assets/Addition/ExtraQuestions/additions_extraquestions.csv';
import { QuestionAnswerOutlined } from "@material-ui/icons";




const allowedExtensions = ["csv"];


var currQuestion;

//used for smart allocation -refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function getAnswer(calculation) {
  const calculationParts = calculation;

  if (calculationParts.length === 3) {
    const [number1, operator, number2] = calculationParts;

    switch (operator) {
      case "-":
        return parseInt(number1) - parseInt(number2);
      case "+":
        return parseInt(number1) + parseInt(number2);
      default:
        break;
    }
  }
  else {
    return 0;
  }
}

function RandomRestrictions(details, split) {
  if (details == undefined){
    return 1;
  }
  let generation = details.split(split);
  var min = 1;
  var max = 100000;
  var cap = 0;
  for (var o = 1; o < generation.length; o++) {
    if (generation[o][0] === "<")
      max = parseInt(generation[o].substring(1));
    else if (generation[o][0] === ">")
      min = parseInt(generation[o].substring(1)) + 1;
    else if (generation[o][0] === "n")
      cap = 1;
    else if (generation[o][0] === "e")
      cap = 2;
    else if (generation[o][0] == "x")
      cap = 3;
    else if (generation[o][0] == "d")
      cap = 4;
  }
  let value = [max, min, cap];
  return value;
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace);
}


function GetImage(image){
  return '/qimages/' + image+".png";
}

function ShuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

//Generates a question from a default question
function GenQuestion(q) {
  //NEW QUESTION FUNCTIONALITY
  if (q.questionline1 != undefined){
    var questionText = q.questionline1.replace("<br>", "\n");
  }else{
    questionText = "";
  }
  
  var questionText2 = "";
  var questionType = "NP";
  var wrong = [];
  var correctAnswer = q.correct_answer;
  var qhtml = "";
  var questionImage = "";
  var qanswers = [];

  if (q.example_question == undefined){
    
    if (q.topic_key == "addsub12S02"){
      qhtml = "<div>";
      qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + q.value_for_images + "</b>";
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml+= "</div>"
    }

    else if (q.topic_key == "addsub12S03"){
      qhtml = "<div style='width: 500px; height: 200px; position: relative; margin: 50%'>";
      var topRow = 10;
      var bottomRow = -50;
      var rightStart = 0;
      var rightPos = 0;
      var rightAdjust = 10;

      //purple
      for (let i = 0; i < q.value_for_images_2; i++) {
        qhtml+= '<img src="' + GetImage("purplecounter") + '"' + "style='position:absolute ; left:"+rightPos+"%; top: "+topRow+"% ; zIndex:-1;transform: scale(0.5,0.5)'" + '></img>';
        rightPos+= rightAdjust;
      }
      rightPos = rightStart;
      //green
      for (let i = 0; i < q.value_for_images_3; i++) {
        qhtml+= '<img src="' + GetImage("greencounter") + '"' + "style='position:absolute ; left:"+rightPos+"%; top: "+bottomRow+"% ; zIndex:-1;transform: scale(0.5,0.5)'" + '></img>';
        rightPos+= rightAdjust;
      }

      qhtml+= "</div>"
    }
    else if (q.topic_key == "addsub12S04"){
      questionText2 = q.questionline2;
      qhtml = "<div style='position: absolute; right: 200%'>";
      qhtml+= '<img src="' + GetImage("BM" + q.value_for_images_3.toString() + q.value_for_images_2.toString()) + '"' + "style='position:absolute ; zIndex:-1; transform: scale(0.5,0.5)'" + '></img>';
      qhtml+= "</div>"
    }
    else if (q.topic_key == "addsub12S07"){
      //then add image?
      qhtml = '<img src="' + GetImage("tenframetablequestion") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPos = 84.5;
      var column = 1;
      var topPosTop = 4;
      var topPosBottom = 28;
      var rightModifier = 7;

      qhtml+= "<div>";
      for (let x = 0; x < q.value_for_images_2; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2){
          topPos = topPosBottom;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'

        if (column == 1){
          rightPos -= rightModifier;
        }
      }
      qhtml+="</div>";
      //loop through ones
      var rightPos = 37.8;
      var column = 1;
      var topPosTop = 4;
      var topPosBottom = 28;
      var rightModifier = 7;

      qhtml+= "<div>";
      for (let x = 0; x < q.value_for_images_3; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2){
          topPos = topPosBottom;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'

        if (column == 1){
          rightPos -= rightModifier;
        }
      }
      qhtml+="</div>";
    }

    else if (q.topic_key == "addsub12S08"){
      qhtml = "<div>";
      qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + q.value_for_images + "</b>";
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml+= "</div>"
    }

    else if (q.topic_key == "addsub12S11"){
      qhtml = "<div>";
      qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + q.value_for_images + "</b>";
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml+= "</div>"
    }

    else if (q.topic_key == "addsub12S12"){
      qhtml = "<div>";
      qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + q.value_for_images + "</b>";
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml+= "</div>"
    }

    else if (q.topic_key == "addsub12S14"){
      qhtml = "<div style='width: 300px; height: 200px; position: relative; margin: 50%; display: flex'>";
      var topRow = 10;
      var bottomRow = -50;
      var rightStart = -70;
      var rightPos = rightStart;
      var rightAdjust = 1;

      qhtml+= '<img src="' + GetImage("jar"+q.value_for_images) + '"' + "style='display:flex ; left:"+rightPos+"%; top: "+topRow+"%'" + '></img>';

      for (let i = 0; i < q.value_for_images_2; i++) {
        //qhtml+= '<img src="' + GetImage("bluegem") + '"' + "style='zIndex:-1;transform: scale(0.2,0.2)'" + '></img>';
        rightPos+= rightAdjust;
      }

      qhtml+= '<img src="' + GetImage("jar"+q.value_for_images_3) + '"' + "style='display:flex ; left:"+rightPos+"%; top: "+topRow+"%'" + '></img>';

      qhtml+= "</div>"
    }

    else if (q.topic_key == "addsub12S15"){
      qhtml = "<div style='width: 500px; height: 200px; position: relative; margin: 50%'>";
      var topRow = 10;
      var bottomRow = -50;
      var rightStart = 0;
      var rightPos = 0;
      var rightAdjust = 10;

      //purple
      for (let i = 0; i < q.value_for_images_2; i++) {
        qhtml+= '<img src="' + GetImage("purplecounter") + '"' + "style='position:absolute ; left:"+rightPos+"%; top: "+topRow+"% ; zIndex:-1;transform: scale(0.5,0.5)'" + '></img>';
        rightPos+= rightAdjust;
      }
      rightPos = rightStart;
      //green
      for (let i = 0; i < q.value_for_images_3; i++) {
        qhtml+= '<img src="' + GetImage("greencounter") + '"' + "style='position:absolute ; left:"+rightPos+"%; top: "+bottomRow+"% ; zIndex:-1;transform: scale(0.5,0.5)'" + '></img>';
        rightPos+= rightAdjust;
      }

      qhtml+= "</div>"
    }

    else if (q.topic_key == "addsub12S17"){
      questionText2 = questionText;
      questionText = "How many gems does Scrambler have?";
      qhtml = "<div style='width: 500px; height: 200px; position: relative; margin: 50%'>";
      var topRow = -90;
      var rightStart = 0;
      var rightPos = 0;
      var rightAdjust = 15;

      //purple
      for (let i = 0; i < q.value_for_images; i++) {
        
        qhtml+= '<img src="' + GetImage("redgem") + '"' + "style='position:absolute ; left:"+rightPos+"%; top: "+topRow+"% ; zIndex:-1;transform: scale(2,2)'" + '></img>';
        rightPos+= rightAdjust;
      }

      qhtml+= "</div>"
    }
    else if (q.topic_key == "addsub12S16"){
      qhtml = "<div style='width: 800px; height: 200px; position: relative; margin: 30%'>";
      qhtml += '<img src="' + GetImage("numberlinecount") + '"' + "style='position:relative ; top: -15%; right:0% ; zIndex:-1'" + '></img>';

      var rightPos = 86.6;
      var column = 1;
      var topPos = 18;
      var rightModifier = 9.45;

      for (let x = 1; x < 10; x++) {
        qhtml += '<div '+ "style='position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>'+x+'</div>'
        rightPos -= rightModifier;
      }
      rightPos = 86.6;
      topPos =  -30;
      //then draw the red arrows
      for (let x = 1; x < 10; x++) {
        if (x <= q.value_for_images && x > (q.value_for_images - q.value_for_images_2)){
          qhtml += '<div '+ "style='color: red; position:absolute ; font-weight: bold; font-size: 12em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>'+'&#8630;'+'</div>'
        }
        rightPos -= rightModifier;
      }

      qhtml+= "</div>"
      
    }

    else if (q.topic_key == "addsub42S09"){
      //questionText2 = q.questionline2;
      qhtml = "<div style = 'transform: translate(-65%, 0); background: #FFF; user-select: none; line-height: 90px; font-size: 4em; margin: 15px 25px;text-align: center;font-weight: 600;border: none;border-radius: 10px; padding: 18px'>" + q.questionline2 + "</div>";
    }
    else if (q.topic_key == "addsub32S01"){
      //make a table
      qhtml = "<table style='width:500px;height:200px;font-size:3em; color:white'>"
      qhtml+= "<tr><th colspan='2' style='background: #550080; width: 100%'>" + q.value_for_images + "</th></tr>";
      qhtml+= "<tr><td style='background: #faad30; width: "+(q.value_for_images_2 / q.value_for_images)*100+"%'>" + q.value_for_images_2 + "</td>";
      qhtml+= "<td style='background: #FFF; width: "+(q.correct_answer / q.value_for_images)*100+"%'></th></tr>";
    }
    else if (q.topic_key == "addsub32S02"){
      qhtml = "<div style = 'width: 500px; transform: translate(-65%, 0); background: #FFF; user-select: none; line-height: 90px; font-size: 4em; margin: 15px 25px;text-align: center;font-weight: 600;border: none;border-radius: 10px; padding: 18px'>" + q.questionline2 + "</div>";
    }
    else if (q.topic_key == "addsub22S04"){
      qhtml= "<table style='width:500px; height:500px'>"
      for (let i = 0; i < q.value_for_images_2/10; i++) {
        qhtml+= "<tr>";
        for (let x = 0; x < 10; x++) {
          qhtml+= "<td style='background: #faad30;'></td>"
          
        }
        qhtml+= "</tr>"
        
      }

      for (let i = 0; i < q.value_for_images_3/10; i++) {
        qhtml+= "<tr>";
        for (let x = 0; x < 10; x++) {
          qhtml+= "<td style='background: #550080;'></td>"

        }
        qhtml+= "</tr>"
        
      }
      qhtml+= "</table>"

      qhtml += "<div style = 'background: #FFF; user-select: none; line-height: 90px; font-size: 4em; margin: 15px 25px;text-align: center;font-weight: 600;border: none;border-radius: 10px; padding: 18px'>" + q.questionline2 + "</div>";
    }
    //new questions ten frame etc
    else if (q.topic_key == "addsub1Sp2S02"){
      qhtml = "<div style='width: 800px; height: 200px; position: relative; margin: 30%'>";
      qhtml += '<img src="' + GetImage("addition/"+q.value_for_images + "tenframe" + q.value_for_images_2) + '"' + "style='position:relative ; top: -15%; right:0% ; zIndex:-1'" + '></img>';
      qhtml+= "</div>"
    }
    else if (q.incorrect_answer_1 == "" && q.questionline2 != ""){//generic for any 2 line numberpad questions
      questionText2 = q.questionline2;
    }
    else if (q.incorrect_answer_1 != "" && q.questionline2 != ""){//generic for any 2 line multiple choice questions
      qhtml = "<div style = 'width: 500px; transform: translate(-65%, 0); background: #FFF; user-select: none; line-height: 90px; font-size: 4em; margin: 15px 25px;text-align: center;font-weight: 600;border: none;border-radius: 10px; padding: 18px'>" + q.questionline2 + "</div>";
    }

    if (q.incorrect_answer_1 != "" &&  q.incorrect_answer_1 != undefined){
      //multichoice
      questionType = "MC";
      //add answers
      qanswers.push({correct: true, value: q.correct_answer});
      qanswers.push({correct: false, value: q.incorrect_answer_1});
      if (q.incorrect_answer_2 != "" && q.incorrect_answer_2 != undefined){
        qanswers.push({correct: false, value: q.incorrect_answer_2});
      }
      if (q.incorrect_answer_3 != "" && q.incorrect_answer_3 != undefined){
        qanswers.push({correct: false, value: q.incorrect_answer_3});
      }
      ShuffleArray(qanswers);
    }


    
    

    let questionObj = {
      question: questionText,
      questionline2: questionText2,
      wronganswers: wrong,
      correct: correctAnswer,
      topic_id: null,
      topic_key: q.topic_key,
      type: questionType,
      version: "new",
      questionHTML: qhtml,
      image: questionImage,
      answers: qanswers
    };
    return questionObj;

  }
  let generatedCalculation = [];
  var correctAnswer = "";
  var tempAnswer = "";
  var templateAnswer = "";
  var calcs = replaceAll(q.example_question, "  ", " ").split(" ");

  console.log(q.example_question);
  console.log(calcs.length);
  generatedCalculation[0] = 0;
  //This covers all questions with one variable
  if (calcs.length === 4) {
    //N is the random number, rand will return the generation restrictions
    var N = 0;
    var rand = RandomRestrictions(calcs[3], "N");

    //Set the calculation to check results for special randoms
    generatedCalculation[0] = 0;
    generatedCalculation[1] = calcs[1];
    generatedCalculation[2] = calcs[2];

    //Only min/max set
    if (rand[2] == 0)
      N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));

    //Re-rolls any numbers that require exhange in the calculation
    else if (rand[2] == 1) {
      var temp = 0;
      while (N == 0 || (N.toString()[0] != temp.toString()[0] && !(N.length === 1 && temp.length === 1))) {
        N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
        generatedCalculation[0] = N;
        temp = getAnswer(generatedCalculation);
      }
    }
    //Re-roll any numbers that do not require exhange in the calculation
    else if (rand[2] == 2) {
      var temp = 0;
      while (N == 0 || (N.toString()[0] != temp.toString()[0] || N.length != temp.length)) {
        N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
        generatedCalculation[0] = N;
        temp = getAnswer(generatedCalculation);
      }
    }

    //Apply the generated number to the question and set the correct answer
    generatedCalculation[0] = N;
    correctAnswer = getAnswer(generatedCalculation);
  }
  //Questions with two variables that need generating
  else if (calcs.length === 5) {
    //Number bonds, generates each of the three numbers of the question
    if (calcs[2] == "N") {
      var min = 1;
      var max = 10;
      if (calcs[4] == "20") {
        min = 11;
        max = 20;
      }
      var total = Math.round(min + Math.random() * (max - min));
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      //generatedCalculation[0] = "Complete the following number bond, " + total + ": " + value2 + ", ?";
      generatedCalculation[0] = value2 + " + □ = " + total;
      correctAnswer = value1;
    }
    //Two number calculations covering, large numbers, factors of 10 and decimals
    else {
      //N is first number
      var N = 0;
      var rand = RandomRestrictions(calcs[3], "N");
      //Normal number with no special parameters
      if (rand[2] == 0)
        N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));
      //Decimal numbers
      else if (rand[2] == 4) {
        N = Math.round(0.1 + Math.random() * 50) / 100;
      }
      //O is the second number
      var O = 0;
      var rand2 = RandomRestrictions(calcs[4], "O");

      //Normal number with no special parameters
      if (rand2[2] == 0)
        O = Math.round(rand2[1] + Math.random() * (rand2[0] - rand2[1]));
      //Power of 10
      else if (rand2[2] == 3) {
        var options = [10, 100, 1000, 10000, 100000];
        O = options[Math.floor(Math.random() * options.length - 0.01)]
      }
      //Decimal number
      else if (rand2[2] == 4) {
        O = Math.round(Math.random() * (N * 50)) / 100;
      }
      //Set the question parameters
      generatedCalculation[0] = N;
      generatedCalculation[1] = calcs[1];
      generatedCalculation[2] = O;

      //Generate the correct answer
      if (calcs[1] == "-")
        correctAnswer = N - O;
      else
        correctAnswer = N + O;

      if (correctAnswer.toString().includes("0.")) {
        correctAnswer = correctAnswer.toFixed(2);
      }
    }
  }
  //Three part question with three generated variables
  else {
    //N is variable 1
    var N = 0;
    var rand = RandomRestrictions(calcs[4], "N");
    N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //O is variable 2
    var O = 0;
    rand = RandomRestrictions(calcs[5], "O");
    O = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //P is variable 3
    //P is variable 3
    var P = 0;
    rand = RandomRestrictions(calcs[6], "P");
    P = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //Build the question
    generatedCalculation[0] = N;
    generatedCalculation[1] = calcs[1];
    generatedCalculation[2] = O;
    generatedCalculation[3] = calcs[3];
    generatedCalculation[4] = P;

    //Set the correct answer
    correctAnswer = N + O + P;
  }
  console.log("QUESTION");
  console.log(q);
  if (q.question_key == "addsubQ34"){//missing number
    var num1 = GenerateRandom(1, 9) * 100;
    var num2 = GenerateRandom(1, 9) * 10;
    var num3 = GenerateRandom(1, 9);

    correctAnswer = num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("+");
    generatedCalculation.push("□");
    generatedCalculation.push("+");
    generatedCalculation.push(num3);
    generatedCalculation.push("=");
    generatedCalculation.push(num1+num2+num3);
  }

  if (q.question_key == "addsubQ35"){//minus 2 digit number from 3 digit number
    var num1 = GenerateRandom(1, 900);
    var num2 = GenerateRandom(1, 90);

    correctAnswer = num1-num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
  }

  if (q.question_key == "addsubQ36"){//missing number 2
    var num1 = GenerateRandom(100, 9999);
    var num2 = GenerateRandom(1, 9);

    correctAnswer = num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push("□");
    generatedCalculation.push("=");
    generatedCalculation.push(num1-num2);
  }

  if (q.question_key == "addsubQ37"){//adding multiples of 10
    var num1 = GenerateRandom(100, 9000);
    var num2array = [10,100,1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];

    correctAnswer = num1+num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("+");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
  }

  if (q.question_key == "addsubQ38"){//adding multiples of 10
    var num1 = GenerateRandom(1001, 9000);
    var num2array = [10,100,1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];

    correctAnswer = num1-num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
  }

  //new questions under here
  if (q.question_key == "addsub3Q1"){//numberbonds 10 only
    generatedCalculation = [];
      var total = 10;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("□");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
  }

  if (q.question_key == "addsub3Q2"){//numberbonds 20 only
    generatedCalculation = [];
      var total = 20;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("□");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
  }

  if (q.question_key == "addsub2Q4"){//Adding 1 or 2 to number that requires exchange
    generatedCalculation = [];
      
    var value1array = [9, 19, 29, 39, 49, 59, 69, 79, 89];
    var value1 = value1array[GenerateRandom(0, value1array.length)];

      var value2array = [1,2];
      var value2 = value2array[GenerateRandom(0, value2array.length)];
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q5"){//Subtracting 1, 2, 3, 4 or 5 from numbers less than 10
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(value1+1,9);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q9"){//Adding two single digit numbers that does not require exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(1,5);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q2"){//Adding 1, 2, 3 or 4 to numbers that gives a sum between 11 and 20
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,15);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q3"){//Adding a single digit number to numbers less than 100 without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,8);
    var value2 = 0;

    if(value1 == 1)
    {
      value2= GenerateRandom(20,98);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89)
      {
        value2= GenerateRandom(20,98);
      }
    }
      
    if(value1 == 2)
    {
      value2= GenerateRandom(20,97);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88)
      {
        value2= GenerateRandom(20,97);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,96);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87)
      {
        value2= GenerateRandom(20,96);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,95);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86)
      {
        value2= GenerateRandom(20,95);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,94);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85)
      {
        value2= GenerateRandom(20,94);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,93);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84)
      {
        value2= GenerateRandom(20,93);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,92);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83)
      {
        value2= GenerateRandom(20,92);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,91);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82)
      {
        value2= GenerateRandom(20,91);
      }
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q20"){//Adding a single digit number to numbers that requires exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(3,8);
    var value2 = 0;

    if(value1 == 3)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87];

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86]

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85]

       value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
     var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83
         , 22 , 32 , 42 , 52 , 62 , 72 , 82]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q6"){ //Subtracting 1, 2, 3 or 4 from numbers more than 10 and less than 19
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,18);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q15"){ //Subtracting a single digit number from numbers less than 100, without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87 || value2 == 97)
      {
        value2= GenerateRandom(20,99);
      }
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q16"){ //Subtracting a single digit number from numbers less than 100 that need to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 3)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95]
      
      value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96
         ,27 ,37 ,47 ,57 ,67 ,77 ,87 ,97]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsubQ31") {
    var firstNum = GenerateRandom(1, 9);
    var secondNum = GenerateRandom(1, 9);
    var thirdNum = GenerateRandom(1,9);
    correctAnswer = firstNum + secondNum + thirdNum;
    generatedCalculation = [];
    generatedCalculation.push(firstNum);
    generatedCalculation.push("+");
    generatedCalculation.push(secondNum);
    generatedCalculation.push("+");
    generatedCalculation.push(thirdNum);
    generatedCalculation.push("=");
  }
  

  let temp2 = [];
  temp2[0] = generatedCalculation;
  temp2[1] = correctAnswer;
  //Creates object to return
  let questionObj = {
    question: temp2,
    questionline2: "",
    answers: correctAnswer,
    correct: correctAnswer,
    topic_id: q.topic_id,
    type: "NP",
    version: "old",
    questionHTML: "",
    image: ""
  };
  return questionObj;
}

export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const [addedExtraQuestions, setAddedExtraQuestions] = useState(false);
  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  const [qImage, setQImage] = useState("");
  const [qHTML, setQuestionHTML] = useState("");

    //const [questionCounter, setQuesitonCounter] = useState(0);

  const { loadedquestions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });

  const [questions, setQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState([]);
    

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }
  
  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  //if question counter is higher than 3 then reset -refeed
  if(questionCounter > 3){
      questionCounter = 0;
  }
  


    
  //Sets the question to a new one.
    //please leave console.logs in case I need to re-test in any of the scripts 
    
     function newQuestion() {
        
        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 
        //get refeed question
        
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
          repeating = true;
          questionCounter = 0;
          currQuestion = refeedQuestions[refeedQuestions.length - 1];
      }


        if ((currQuestion.image != "" && currQuestion.image != undefined)) {
          setQImage(require('../../assets/NumberAndPlace/images/' + currQuestion.image+".png"));
        }else{
          setQImage("");
        }
        if(currQuestion.questionHTML != "" && currQuestion.questionHTML != undefined){
          setQuestionHTML(currQuestion.questionHTML);
        }else{
          setQuestionHTML("");
        }

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
        */

        
        console.log("NEW QUESTION=");
        console.log(currQuestion);
        setCurrentQuestion(currQuestion);
    }


    //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
    function Reset() {

        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
    }

    function reduceTimer() {
      console.log(waitTime);
    setWaitTime(waitTime - 1);
    }

    useEffect(() => {
      if (waitTime > 0) {
          var waitttimerID = setInterval(() => reduceTimer(), 1000);
          return () => {
              clearInterval(waitttimerID);
          };
      } else if(waitTime != -10){
  
          setColouredFeedback(false);
          newQuestion();
      }
    },[waitTime]);

    async function checkResultMultipleChoice(value, callback) {

      //set the current question to the last question -refeed
        questionCounter = questionCounter +1;
        lastQuestion = currQuestion.question;
        console.log("press button");
        console.log(value);
    
        var isCorrect = true;
        if (value) {
          //correct answer
          if (value.correct == true) {
            setCorrectQuestions([...correctQuestions, currQuestion]);
            let multiplier = combo > 0 ? combo + 1 : 1;
            multiplier = multiplier > 5 ? 5 : multiplier;
            setScore(score + multiplier * 10);
    
            if (combo < 99) {
              setCombo(combo + 1);
            }
            if (combo > maxCombo) {
              setMaxCombo(combo);
            }
            //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
            if (repeating) {
                refeedQuestions.pop();
                repeating = false;
            }
    
            let result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: value.value
          };
          setNoFeedback([...nofeedback, result]);
    
            newQuestion();
          }
          //incorrect answer
          else {
              questionCounter = 0;
            isCorrect = false;
            //push question to refeed if user gets it wrong - refeed
            refeedQuestions.push(currQuestion);
    
            setIncorrectQuestions([...incorrectQuestions, currQuestion]);
            if (combo === 0 && score >= 10) {
              setScore(score - 10);
            } else {
              setCombo(0);
            }
            let result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: value.value
            };
    
            setFeedback([...feedback, result]);
            setColouredFeedback(true);
            setWaitTime(2);
          }
    
          //Generates a new question
          //newQuestion();
    
        }
      }

  //Called on click
    async function checkResult(value, callback) {

     //set the current question to the last question -refeed
      questionCounter = questionCounter +1;
      lastQuestion = currQuestion.question;

      var isCorrect = true;

    if (value) {
      console.log(currQuestion.correct + " vs " + value);
      //correct answer
        var decString = "0." + value;
      
      var curCorrect = currQuestion.correct;
      if (curCorrect[3] == "0")
      {
        curCorrect = parseFloat(curCorrect).toFixed(1);
        decString =  parseFloat(decString).toFixed(1);
      }
      if ((currQuestion.correct.toString().includes("0.") && curCorrect == decString) || (currQuestion.correct == value)) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
            refeedQuestions.pop();
            repeating = false;
        }
        let result;
        if (Array.isArray(currQuestion.question)){
          result = {
            question: currQuestion.question[0].join(" "),
            correct: currQuestion.correct,
            incorrect: value
          };
        }
        else{
          result = {
            question: currQuestion.question,
            correct: currQuestion.correct,
            incorrect: value
          };
        }
        
      setNoFeedback([...nofeedback, result]);
      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
         //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currQuestion]);

        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }
        let result;

        if (currQuestion.correct.toString().includes("0.")) {
          if (Array.isArray(currQuestion.question)){
            result = {
              question: currQuestion.question[0].join(" "),
              correct: currQuestion.correct,
              incorrect: "0." + value
            };
           
          }else{
            result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: "0." + value
            };
          } 
          setFeedback([...feedback, result]);
        }
        else {
          let result;
          if (Array.isArray(currQuestion.question)){
            result = {
              question: currQuestion.question[0].join(" "),
              correct: currQuestion.correct,
              incorrect: value
            };
          }
          else{
            result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: value
            };
          }
          setFeedback([...feedback, result]);
        }
      }

      if (callback) {
        await callback(isCorrect, currQuestion[1]).then(() => {
          newQuestion();
        });
      } else {
        newQuestion();
      }
    }
    }


    function AddExtraQuestions(){
      console.log("Adding Extra Questions");
      console.log(year1extraquestions);
      //import from CSV
      Papa.parse(year1extraquestions, {
        download: true,
        header: true,
        complete: function (results) {
          console.log("Extra Questions:");
          console.log(results.data)
          console.log(loadedquestions);
          console.log(status);
          let addMe = [];
          //check set topics and see if in extra questions
          for (let i = 0; i < props.topicKeys.length; i++) {
            const topicKey = props.topicKeys[i];
            console.log(topicKey);
            for (let x = 0; x < results.data.length; x++) {
              const extraQ = results.data[x];
              //console.log(extraQ);
              if (extraQ.topic_key == topicKey){
                console.log("found you")
                addMe.push(extraQ);
              }
            }
          }

          if (loadedquestions != null){
            //if already loaded
            console.log("add loaded questions");
            for (let i = 0; i < loadedquestions.length; i++) {
              const loadedquesiton = loadedquestions[i];
              addMe.push(loadedquesiton);
            }
        }
          console.log("ALLQUESTIONS:");
          console.log(addMe);
          setAddedExtraQuestions(true);
          setQuestions(addMe);
          console.log("done adding extra questions");
        },
      });
      
      
    }



  //Set the first question, called until questions are defined
  useEffect(() => {
    console.log(questions);
    if (questions !== undefined && questions.length > 0) {
        console.log("Starting Game");
        var sample = newQuestion();
        //setCurrentQuestion(sample);
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
      AddExtraQuestions();
    }
  }, [status]);

  useEffect(() => {
    console.log(currentQuestion);
    
  }, [currentQuestion]);


  function ComboImage(){
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo"+comboNum+".gif";
     //return <img src= {{imageName}} style={{position:"relative"}}></img>
     if (combo < 3){
       return <img style={{position: "absolute",top:"70%",left:"15%"}} src={require("../../assets/"+imageName)}></img>
     }else{
      return <img style={{position: "absolute",top:"56%",left:"5%"}} src={require("../../assets/"+imageName)}></img>
     }

     
}
console.log(props);
  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
          parent={props}
          correct={correctQuestions}
          incorrect={incorrectQuestions}
          score={score}
          defaultTimer={timer}
          questionLimit={questionMax}
          onBack={() => {
              props.onBack();
              Reset();
          }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          setAddedExtraQuestions(false);
          //setQImage("");
          //setQuestionHTML("");
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${props.gameBackground})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={1920}>
            <Body>
            {currentQuestion !== undefined &&
            <div style={{ alignItems: "center", position: "absolute", display: "block", right: "65%"}}>
              {currentQuestion.questionline2 != "" &&
              <div>
              <Question2>{currentQuestion.questionline2}</Question2>
              <br/>
              </div>
              }
                      {(currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.questionHTML == "" && currentQuestion.type == "NP") ? (
                        <img src={qImage}></img>
                      ) : (
                          <div></div>
                        )}

                        {currentQuestion.questionHTML != "" && currentQuestion.type == "NP" ? (
                        <DynamicStyle >
                          <div dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}
                        </div>
              }

              <div>
                {currentQuestion !== undefined && currentQuestion.version == "old" &&

                <Calculator
                  currentQuestion={currentQuestion.question}
                  onSubmitted={checkResult}
                />
              }
              {currentQuestion !== undefined && currentQuestion.version == "new" && currentQuestion.type == "NP" &&
              <CalculatorNew
                currentQuestion={currentQuestion}
                onSubmitted={checkResult}
              />
              }
              {currentQuestion !== undefined && currentQuestion.version == "new" && currentQuestion.type == "MC" &&
              <div style={{display: "flex", justifyContent: "center"}}>
                <Question2 style={{width: "1000px", position: "absolute", right: "24%", top: "10%"}}>{currentQuestion.question}</Question2>
                      {(currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.questionHTML == "") ? (
                        <img src={qImage}></img>
                      ) : (
                          <div></div>
                        )}

                        {currentQuestion.questionHTML != "" ? (
                        <DynamicStyle >
                          <div style={{position: "fixed", right: "20%", top: "25%"}} dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}

                <div style={{position: "fixed", width: "100%", right: "0%", top: "60%", display: "flex"}}>
                  {showColouredFeedback == false && currentQuestion.answers !== undefined &&
                    currentQuestion.answers.map(answer => (
                      <Button
                        value={<div dangerouslySetInnerHTML={answer.value} />}
                        style={{ flex: 1, marginInline: "5%" }}
                        onClick={() => checkResultMultipleChoice(answer, true)}
                      >
                        <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                      </Button>
                    ))}

                  {showColouredFeedback == true && currentQuestion.answers !== undefined &&
                    currentQuestion.answers.map(answer => (
                      <Button
                        value={<div dangerouslySetInnerHTML={answer.value} />}
                        style={{ flex: 1, marginInline: "5%" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                      >
                        <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                      </Button>
                    ))}
                    </div>
                </div>
              }


              </div>
              <Combo>
                <span style={{ fontSize: "50px" }}>{combo}</span>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>

            </Body>
            
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url();
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: flex-end;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
        background: #FFF;
        user-select: none;
        width: 1000px;
        height: 120px;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
      `;

      const Question2 = styled.div`
        background: #FFF;
        user-select: none;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
        padding: 18px;
      `;

const Button = styled.div`
        text-align: center;
        height: 150px;
        line-height: 100px;
        font-size: 4em;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        padding: 0.5em;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
        position: realtive;
      top: 35%;
      //left: -15%;
      //width: 100%
      //text-align: center
      font-size 2em;
      //50%
    `;